/*
 * Developed for EPSON AMERICA INC. by Softeq Development Corporation
 * http://www.softeq.com
 */

export const ADDED_EXPIRATION_YEARS = 11

export enum CARD_TYPES {
  visa = 'VISA',
  dc = 'DC',
  amex = 'AMEX',
  disc = 'DISC',
  mc = 'MC',
  custom = 'CUSTOM',
}
